import React, {useRef, useEffect} from 'react';
import {Grid, Button, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import lottie from 'lottie-web';
import Path5 from '../Paths/path5';

const useStyles =makeStyles((themes)=>({
    
    container:{
        textAlign:"center"
    },
    svg:{
        margin:"auto"
    },

    footer:{
        backgroundColor:"rgb(58, 110, 165)",
    },
    resume:{
        backgroundColor:"white",
        color:"rgba(22,33,90,255)",
        margin:"20px",
        marginBottom:"20px",
        width:"120px",

        [themes.breakpoints.up('md')]: {
            marginLeft:"100px",
            margin:"50px"
          },

        '&:hover':{
            backgroundColor:"rgb(235, 235, 235)"
        },
    },

    text:{
        color:"white",
        marginLeft:"10px",
        fontSize:"12px",
        marginBottom:"50px",
        [themes.breakpoints.up('md')]:{
            marginTop:"50px",
            textAlign:"right",
            fontSize:"20px",
            marginRight:"50px"
        }
    },
   
}))

export default function Footer(){

    const classes= useStyles();
    const container =useRef(null);

    useEffect(()=>{

        lottie.loadAnimation({
            container:container.current,
            renderer: "svg",
            loop: true,
            autoplay: true,
            animationData: require('../Lotties/end.json')
        })
    },[])

    return(
        <div>
            <Grid container className={classes.container}>
                <Grid item md={1}></Grid>
                <Grid item xs={12} md={10}> 
                    <Path5 className={classes.svg}></Path5>
                </Grid>
                <Grid item md={1}></Grid>
            </Grid>
            <Grid container className={classes.container}>
                <Grid item md={4}></Grid>
                <Grid item xs={12} md={4}>
                    <div ref={container}></div>
                </Grid>
                <Grid item md={4}></Grid>
            </Grid>

            <Grid container className={classes.footer}>
                <Grid item xs={12} md={6}>
                    <Button className={classes.resume}>Resume</Button>
                    <Button className={classes.resume}>Blog</Button>
                </Grid>

                <Grid item xs={12} md={6}>
                    
                    <Typography className={classes.text}> • Designed and Developed by Akash Ekanayaka</Typography>
                
                </Grid>
            </Grid>
        </div>
    )
}